<template>
<b-container>
    <b-row>
        <b-col>
            <div class="my-3 p-3 bg-white rounded shadow-sm">
                <h4 class="border-bottom border-gray pb-2 mb-0">No. servicio</h4>
                <div class="media text-muted pt-3">
                    <b-row>
                        <b-col sm="12" class="mt-3 mb-3">
                            <b-form-group label="Buscar" label-for="filterInput" class="mb-0">
                                <b-input-group size="sm">
                                <b-form-input v-model="packagesTable.filter" type="search" id="filterInput"></b-form-input>
                                <b-input-group-append>
                                    <b-button class="boton_createch" :disabled="!packagesTable.filter" @click="packagesTable.filter = ''">Borrar</b-button>
                                </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12">
                            <b-table :items="orders" :fields="fields" 
                                :current-page="packagesTable.currentPage"
                                :per-page="packagesTable.perPage"
                                :filter="packagesTable.filter"
                                :filterIncludedFields="packagesTable.filterOn"
                                @filtered="onFiltered"> 
                                 <template v-slot:cell(actions)="row">
                      <!-- <b-button size="sm" @click="view(row.item._id)" class="mr-1" variant="light"><i class="far fa-eye"></i></b-button> -->
                      <b-button @click="view(row.item)" class="mr-1 btn-sm" variant="light">
                        <i class="far fa-edit"></i>
                      </b-button>

                   
                    </template>
                            </b-table>
                        </b-col>
                        <b-col sm="12">
                            <b-pagination
                                v-model="packagesTable.currentPage"
                                :total-rows="packagesTable.totalRows"
                                :per-page="packagesTable.perPage"
                                align="fill"
                                size="sm"
                                class="my-0"
                                >
                            </b-pagination>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </b-col>
    </b-row>
    
     
</b-container>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
             usuarios: [],
            orders: [],
            items: [
                { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
                { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
                { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
                { age: 38, first_name: 'Jami', last_name: 'Carney' }
            ],
            fields: [ 
                { key: 'snumber', label: 'No. Servicio' },  
                { key: 'tariff.name', label: 'Tarifa' },
                { key: 'address', label: 'Dirección' },
                { key: 'city.name', label: 'Ciudad' },
                { key: 'owner.name', label: 'Nombre' }, 
                { key: 'owner.email', label: 'Email' }, 
                { key: 'actions', label: '' }
            ],
            packagesTable: { 
                totalRows: 1,
                currentPage: 1,
                perPage: 5,
                pageOptions: [5, 10, 15],
                filter: null,
                filtpackagesTableerOn: []
            },
            deleteModal: {
                id: "info-modal",
                title: "",
                eliminar: null
            }
        }
    },
     
    created() {
        this.gets();
    },
    methods: {
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.packagesTable.totalRows = filteredItems.length
        this.packagesTable.currentPage = 1
      },
       
        gets() { 
            axios
            .get("snumbers")
            .then(res => { 
                if (res.data) {  
                    this.orders = res.data;
                    this.packagesTable.totalRows = res.data.length;
                } 
            })
            .catch(error => {
                this.isLoading = false; 
            });
        },
        view(item){ 
            this.$router.push({ name: "NoServicio_id",  params: { id: item._id  } });
        }
    }
}
</script>

<style>

</style>